import { gql } from "@apollo/client";

export const RECENT_INSTALLS_QUERY = gql`
  query recentInstalls(
    $companyFilters: CompanyFilter!
    $productIds: [Int]!
    $localizeInstalls: Boolean = true
    $companyMatchFile: CompanyMatchFilter
  ) {
    recentInstalls(
      companyFilters: $companyFilters
      productIds: $productIds
      localizeInstalls: $localizeInstalls
      companyMatchFile: $companyMatchFile
    ) {
      productId
      productName
      companyName
      revenueMax
      revenueMin
      firstVerified
      vendorUrl
      companyUrl
      intensity
    }
  }
`;

export interface RecentInstall {
  productId: number;
  productName: string;
  vendorUrl: string;
  companyName: string;
  companyUrl: string;
  revenueMax: number;
  revenueMin: number;
  firstVerified: string;
  intensity: number;
}
